import React, { useState, useCallback, useEffect, memo } from "react";

/* ================= IMAGES ================= */

import Gallery1 from "../assets/images/NSS/1.webp";
import Gallery2 from "../assets/images/NSS/2.webp";
import Gallery3 from "../assets/images/NSS/3.webp";
import Gallery4 from "../assets/images/NSS/4.webp";
import Gallery5 from "../assets/images/NSS/5.webp";
import Gallery6 from "../assets/images/NSS/6.webp";
import Gallery7 from "../assets/images/NSS/7.webp";
import Gallery8 from "../assets/images/NSS/8.webp";
import Gallery9 from "../assets/images/NSS/9.webp";
import Gallery10 from "../assets/images/NSS/10.webp";
import Gallery11 from "../assets/images/NSS/11.webp";
import Gallery12 from "../assets/images/NSS/12.webp";
import Gallery13 from "../assets/images/NSS/13.webp";
import Gallery14 from "../assets/images/NSS/14.webp";
import Gallery15 from "../assets/images/NSS/15.webp";
import Gallery16 from "../assets/images/NSS/16.webp";
import Gallery17 from "../assets/images/NSS/17.webp";
import Gallery18 from "../assets/images/NSS/18.webp";
import Gallery19 from "../assets/images/NSS/19.webp";
import Gallery20 from "../assets/images/NSS/20.webp";
import Gallery21 from "../assets/images/NSS/21.webp";
import Gallery22 from "../assets/images/NSS/22.webp";

/* ================= DATA ================= */

const GALLERY_IMAGES = [
  Gallery1, Gallery2, Gallery3, Gallery4, Gallery5, Gallery6,
  Gallery7, Gallery8, Gallery9, Gallery10, Gallery11, Gallery12,
  Gallery13, Gallery14, Gallery15, Gallery16, Gallery17, Gallery18,
  Gallery19, Gallery20, Gallery21, Gallery22
];

/* ================= ITEM ================= */

const BentoItem = memo(({ src, index, onClick }) => {
  const [loaded, setLoaded] = useState(false);

  const handleClick = useCallback(() => {
    onClick(index);
  }, [onClick, index]);

  return (
    <div className={`nsp-bento__item nsp-bento__item--${index + 1}`} onClick={handleClick}>
      <img
        src={src}
        alt="NSP gallery"
        loading={index === 0 ? "eager" : "lazy"}
        decoding="async"
        onLoad={() => setLoaded(true)}
        className={loaded ? "loaded" : "loading"}
      />

      <div className="nsp-bento__overlay" />

      {index === 0 && (
        <span className="nsp-bento__badge">
          NSP Gallery
        </span>
      )}
    </div>
  );
});

BentoItem.displayName = "BentoItem";

/* ================= LIGHTBOX ================= */

const Lightbox = ({ images, index, onClose, onNext, onPrev }) => {
  if (index === null) return null;

  const img = images[index];

  return (
    <div className="nsp-lightbox" onClick={onClose}>
      <button className="close" onClick={onClose}>×</button>

      <button className="prev" onClick={(e) => { e.stopPropagation(); onPrev(); }}>
        ‹
      </button>

      <img src={img} alt="" onClick={(e) => e.stopPropagation()} />

      <button className="next" onClick={(e) => { e.stopPropagation(); onNext(); }}>
        ›
      </button>
    </div>
  );
};

/* ================= MAIN ================= */

export default function NspGallery() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const open = useCallback((i) => setLightboxIndex(i), []);
  const close = useCallback(() => setLightboxIndex(null), []);

  const next = useCallback(() => {
    setLightboxIndex((i) => (i + 1) % GALLERY_IMAGES.length);
  }, []);

  const prev = useCallback(() => {
    setLightboxIndex((i) => (i - 1 + GALLERY_IMAGES.length) % GALLERY_IMAGES.length);
  }, []);

  // keyboard navigation + preload
  useEffect(() => {
    if (lightboxIndex === null) return;

    const handleKey = (e) => {
      if (e.key === "Escape") close();
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };

    window.addEventListener("keydown", handleKey);

    // preload next/prev
    const nextImg = new Image();
    nextImg.src = GALLERY_IMAGES[(lightboxIndex + 1) % GALLERY_IMAGES.length];

    const prevImg = new Image();
    prevImg.src = GALLERY_IMAGES[(lightboxIndex - 1 + GALLERY_IMAGES.length) % GALLERY_IMAGES.length];

    return () => window.removeEventListener("keydown", handleKey);
  }, [lightboxIndex, close, next, prev]);

  return (
    <section className="nsp-bento-section">
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
          <p className="nsp-label">Life at ECL</p>
          <h2 className="nsp-title">NSP Gallery</h2>
          <p className="nsp-sub">
            Moments from our National Service Personnel programme
          </p>
        </div>

        {/* Bento */}
        <div className="nsp-bento">
          {GALLERY_IMAGES.map((img, i) => (
            <BentoItem key={i} src={img} index={i} onClick={open} />
          ))}
        </div>
      </div>

      {/* Lightbox */}
      <Lightbox
        images={GALLERY_IMAGES}
        index={lightboxIndex}
        onClose={close}
        onNext={next}
        onPrev={prev}
      />
    </section>
  );
}